export type RoomFeaturesInfo = {
  [key: string]: {
    iconName?: string;
    label: string;
  };
};

export const ROOM_FEATURES_INFO: RoomFeaturesInfo = {
  floor: {
    iconName: "stairs",
    label: "card-rooms.feature.floor",
  },
  surface: {
    iconName: "surface",
    label: "card-rooms.feature.surface",
  },

  bathroom_private: {
    iconName: "bathroom",
    label: "card-rooms.feature.bathroom.private",
  },
  bathroom_shared: {
    iconName: "bathroom",
    label: "card-rooms.feature.bathroom.shared",
  },
  rooms: {
    iconName: "plan",
    label: "card-rooms.feature.rooms",
  },

  side: {
    iconName: "photograph",
    label: "card-rooms.feature.side",
  },
  buildingName: {
    iconName: "office-building",
    label: "card-rooms.feature.buildingName",
  },
};

export const ORDERED_FEATURE_KEYS = [
  "bathroom_private",
  "bathroom_shared",
  "floor",
  "surface",
  "rooms",
  "side",
  "buildingName",
] as const;
